export default () => ({
  investorId: ''
});
